import React, { forwardRef, useEffect } from "react";
import { X } from "react-feather";
import { PropTypes } from "prop-types";
import classNames from "classnames";

const Dialog = forwardRef(
  (
    {
      openModal,
      closeModal,
      title = null,
      tag = null,
      tagStyle = "bg-apricot text-white",
      modalStyle = "sidebar",
      className = "",
      animation = "slide-in-right",
      children,
    },
    ref,
  ) => {
    let modalClass = "";

    if (modalStyle === "popup") {
    } else if (modalStyle === "sidebar") {
      modalClass = "my-0 mr-0 flex min-h-screen w-full max-lg:m-4 lg:w-[50svw]";
    }

    if (className !== "") {
      modalClass += ` ${className}`;
    }

    if (ref === null) {
      ref = React.createRef();
    }

    useEffect(() => {
      if (openModal) {
        ref.current?.showModal();
      } else {
        ref.current?.close();
      }
    }, [openModal]);

    return (
      <dialog
        ref={ref}
        onCancel={closeModal}
        className={modalClass}
        data-animation={animation}
      >
        <div className="relative flex w-full flex-col gap-8 bg-white pb-8 pl-8 pr-8 pt-4">
          <header className="sticky top-0 z-10 flex justify-between bg-white pt-4">
            {tag && (
              <div className="max-w-[calc(100%-32px)]">
                <span
                  className={classNames(
                    "rounded-br-2xl px-4 py-2.5 text-sm font-semibold",
                    tagStyle,
                  )}
                >
                  {tag}
                </span>
              </div>
            )}
            {title && !tag && (
              <h2 className="max-w-[calc(100%-32px)] text-2xl font-bold">
                {title}
              </h2>
            )}

            <div className="flex grow justify-end">
              <button onClick={closeModal} aria-label="Close" type="button">
                <X size={24} aria-hidden="true" />
              </button>
            </div>
          </header>
          {title && tag && (
            <h2 className="max-w-[calc(100%-32px)] text-2xl font-bold">
              {title}
            </h2>
          )}
          {children}
        </div>
      </dialog>
    );
  },
);

Dialog.propTypes = {
  title: PropTypes.string,
  tag: PropTypes.string,
  tagStyle: PropTypes.string,
  openModal: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  modalStyle: PropTypes.oneOf(["popup", "sidebar"]),
  className: PropTypes.string,
  animation: PropTypes.oneOf(["slide-in-right", "fade-in"]),
};

export { Dialog };
